export let PasswordErrorOption;
(function (PasswordErrorOption) {
  PasswordErrorOption["Breached"] = "breached";
})(PasswordErrorOption || (PasswordErrorOption = {}));